import React from "react"
import { blog } from "../../dummydata"
import { motion } from "framer-motion"
import { User, Calendar, MessageSquare, ArrowRight } from "lucide-react"

const BlogCard = () => {
  return (
    <>
      {blog.map((val, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.1 }}
          className='blog-item'
        >
          <div className='blog-img-box'>
            <img src={val.cover} alt={val.title} />
          </div>
          <div className='blog-content'>
            <div className='blog-meta'>
              <div className='meta-item'>
                <User size={14} />
                <span>{val.type}</span>
              </div>
              <div className='meta-item'>
                <Calendar size={14} />
                <span>{val.date}</span>
              </div>
              <div className='meta-item'>
                <MessageSquare size={14} />
                <span>{val.com}</span>
              </div>
            </div>
            <h3 className='blog-title'>{val.title}</h3>
            <p className='blog-desc'>{val.desc}</p>
            <button className='blog-btn'>
              Read Full Article <ArrowRight size={16} />
            </button>
          </div>
        </motion.div>
      ))}
    </>
  )
}

export default BlogCard
